import { FunctionComponent, PropsWithChildren } from 'react';

import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const AllowDownloadingCheckboxInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, handleChange, handleBlur } = props;

  return (
    <FormControl
      data-testid="allow-downloading-checkbox-input-form-control"
      className="not-centered"
    >
      <FormControlLabel
        label="Allow Downloading while using 5G"
        value={values.is5GDownloadingAllowed ?? true}
        onChange={handleChange}
        onBlur={handleBlur}
        control={
          <Checkbox
            id="is5GDownloadingAllowed"
            className="checkbox-input"
            checked={values.is5GDownloadingAllowed}
          />
        }
      />
    </FormControl>
  );
};
